import {
  responsiveHeight,
  responsiveWidth,
  useResponsiveFontSize,
  useResponsiveHeight,
  useResponsiveWidth,
} from '@/hooks/useResponsiveDimensions';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Choice } from './choice';

export function ReadingChoices({ choices, questionText }) {
  const { bottom, top, right, left } = useSafeAreaInsets();
  const [correct, setCorrect] = useState(false);
  const choicesDep = JSON.stringify(choices);
  const verticalSafeAreaInsets = top + bottom;
  const horizontalSafeAreaInsets = right + left;

  const responsiveStyles = StyleSheet.create({
    container: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center',
      height: responsiveHeight(62) - verticalSafeAreaInsets,
      width: responsiveWidth(90) - horizontalSafeAreaInsets,
      marginHorizontal: useResponsiveWidth(2),
    },
    textSize: {
      fontSize: useResponsiveFontSize(2.2),
      marginBottom: useResponsiveHeight(3),
    },
  });

  const changeCorrect = useCallback(() => {
    setCorrect(true);
  }, []);
  const items = useMemo(() => {
    let choicesCloned = [...choices];
    return choicesCloned.map((choice, i) => {
      const isLastBox = choicesCloned.length - 1 === i;
      const key = choice.choiceText;
      return (
        <Choice
          key={key}
          isLastBox={isLastBox}
          changeCorrect={changeCorrect}
          isDisabled={correct}
          choice={choice}
        />
      );
    });
  }, [choicesDep, correct]);

  useEffect(() => {
    if (!correct) {
      return;
    }
    setCorrect(false);
  }, [choicesDep]);

  return (
    <View style={responsiveStyles.container}>
      <Text style={responsiveStyles.textSize}>{questionText}</Text>
      {items}
    </View>
  );
}
